<template>
  <component :is="tag" class="notification-event-group">
    <p class="notification-event-group__header">
      {{ $t(`notifications-center.group.${group.key}`) }}
    </p>
    <template v-for="entry in group.entries">
      <NotificationCompetitorThread
        v-if="entry.type === 'thread'"
        :key="entry.notifications[0].id"
        :competitor-name="entry.competitorName"
        :notifications="entry.notifications"
        @open="$emit('open', $event)"
        @mark-read="$emit('mark-read', $event)"
      />
      <NotificationItem
        v-else
        :key="entry.notification.id"
        :notification="entry.notification"
        :tender="tenderById(entry.notification.content.subjectId)"
        :opportunity="opportunityById(entry.notification.content.subjectId)"
        @open="$emit('open', entry.notification)"
        @mark-read="$emit('mark-read', entry.notification)"
      />
    </template>
  </component>
</template>

<script>
import { mapGetters } from 'vuex';
import NotificationCompetitorThread from '@/components/notifications-center/NotificationCompetitorThread.vue';
import NotificationItem from '@/components/notifications-center/NotificationItem.vue';

// The notifications of one period ("Today", "This week"...), as groupNotificationEvents makes them.
export default {
  name: 'NotificationEventGroup',
  components: {
    NotificationCompetitorThread,
    NotificationItem,
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
    tag: {
      type: String,
      default: 'div',
    },
  },
  computed: {
    ...mapGetters('notifications', ['tenderById', 'opportunityById']),
  },
};
</script>

<style lang="scss" scoped>
.notification-event-group {
  & + & {
    margin-top: $space-md;
    border-top: 1px solid $color-border;
    padding-top: $space-sm;
  }

  &__header {
    margin: 0;
    padding: $space-sm $space-sm $space-1;
    color: $color-text-muted;
    font-size: $font-size-xsmall;
    font-weight: $font-weight-bold;
    text-transform: uppercase;
  }
}
</style>
